import styled from "styled-components";

export const HeaderContainer = styled.div`
  width: 100%;
  background: "var(--background-header)";
  background-color: var(--background-header);
  height: ${({ headerHeight }) =>
    headerHeight ? `${headerHeight}px` : "var(--theme-header-height)"};
  border-bottom: var(--header-border);
  display: grid;
  grid-template-columns: 20% auto 20%;
  align-items: center;
  position: fixed;
  z-index: 1000;
`;

export const HeaderColumn = styled.div`
  grid-column: ${({ position }) => position};
  justify-self: ${({ justify }) => (justify ? "center" : null)};
`;

export default { HeaderContainer, HeaderColumn };
